export function LogoMark({ src, className = "", testId = "brand-logo" }) {
  return (
    <img
      className={`logo-mark ${className}`}
      src={src}
      alt="Martinez Landscaping, LLC logo"
      data-testid={testId}
    />
  );
}
